import React from 'react';
import parse from 'html-react-parser';
import moment from 'moment';
import clsx from 'clsx';
import * as media from './Media.module.scss';

const Media = React.forwardRef((props, ref) => {
  const {
    date,
    title,
    html,
    className,
    ...other
  } = props;

  return (
    <div ref={ref} className={clsx(media.wrapper, className)} {...other}>
      <time className={media.date}>{moment(date).format('YYYY-MM-DD')}</time>
      <div className={media.col}>
        <p className={media.title}>{title}</p>
        {html && <div>{parse(html)}</div>}
      </div>
    </div>
  );
});

export default Media;
